module.exports = __webpack_public_path__ + "static/media/0.d3bd3e97.svg";